import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../store/context/authContext";

const ProtectedRoute = ({ children }) => {
  const { logging } = useAuth();

  useEffect(() => {
    // const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");
      // if (expirationTime) {
      //   const currentTime = Date.now();
      //   if (currentTime > expirationTime) {
      //     localStorage.removeItem("token");
      //     localStorage.removeItem("tokenExpiration");
      //     localStorage.removeItem("user");
      //     return false;
      //   }
      // }
      // return true;
    // };

    // const tokenValid = checkTokenExpiration();

    if (!token) {
      window.location.href = "/login";
    }
  }, [logging]);

  const token = logging();
  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
